import React from 'react'
import PropTypes from 'prop-types'
import TitleWithBar from 'components/TitleWithBar'
import style from './style.scss'//NOSONAR

const TechnicalTable = (props) => {

    const { product } = props;
    let allFeature = (((product && product.flag_details && product.flag_details.length > 1) || (product && product.flag_nutricional && product.flag_nutricional.length > 1)) && (product && product.flag_technical && product.flag_technical.length > 1));
    let productFeature =  product && product.flag_technical && product.flag_technical.length >= 4 && allFeature ? product.flag_technical.slice(0,4) :  product.flag_technical;

    return (
        <>
            {product.flag_technical && <div className="product-page-container-technical-information">
                <TitleWithBar title="Características" customClassName="technical-information-title" />

                <div className="technical-information-flags">
                    {product.flag_technical && productFeature.map((item, i) => {
                        return (
                            <div key={i} className="technical-information-flags-container">
                                <div className="technical-information-flags-title-container">
                                    <span className="technical-information-flags-title">{item}</span>
                                </div>
                                <div className="technical-information-flags-value-container">
                                    <span className="technical-information-flags-value">{product[item] && product[item].join(' - ')}</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>}
        </>
    )


}

TechnicalTable.propTypes = {
    product: PropTypes.object,
}

export default TechnicalTable
